
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface FormFieldsProps {
  title: string;
  description: string;
  content: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export function FormFields({ title, description, content, onChange }: FormFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="title">Τίτλος</Label>
        <Input 
          id="title" 
          name="title" 
          value={title} 
          onChange={onChange} 
          placeholder="Εισάγετε τίτλο άρθρου" 
          required 
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="description">Σύντομη περιγραφή</Label>
        <Textarea 
          id="description" 
          name="description" 
          value={description} 
          onChange={onChange} 
          placeholder="Εισάγετε μια σύντομη περιγραφή" 
          required 
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="content">Περιεχόμενο</Label>
        <Textarea 
          id="content" 
          name="content" 
          value={content} 
          onChange={onChange} 
          placeholder="Εισάγετε το περιεχόμενο του άρθρου" 
          rows={5}
          required
        />
      </div>
    </>
  );
}
